import util from '@bmp-vue/core/api/util'

const controller = 'PerfilOperadorFrontEnd'
export default Object.assign({}, util.GetCrud(controller, null), {})
